import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

function useBreadcrumbHandler(actualFolder, startup) {
  const [breadcrumb, setBreadcrumb] = useState([]);
  const literals = useSelector(({ i18n }) => i18n.literals.dataRoom);

  useEffect(() => {
    if (actualFolder && !['recent', 'bookmark', `root.startup.${startup.id}`].includes(actualFolder.id)) {
      setBreadcrumb(prev => {
        if (!actualFolder.name) {
          return [{ name: actualFolder.id, path: `#${actualFolder.id}` }];
        }
        const folderIndex = prev.findIndex(b => b.id === actualFolder?.id);
        if (folderIndex === -1) {
          return [...prev, {
            id: actualFolder.id,
            name: literals.defaultFolders[actualFolder.name] || actualFolder.name || actualFolder.id,
            path: `${actualFolder.name ? `?name=${actualFolder.name}` : ''}#${actualFolder.id}`,
          }];
        }
        return prev.slice(0, folderIndex + 1);
      });
    } else {
      setBreadcrumb([]);
    }
  }, [actualFolder, literals, startup.id]);

  return breadcrumb;
}

export default useBreadcrumbHandler;
